module.exports = __webpack_public_path__ + "static/media/cgt_fr.15ca912a.svg";